export const FIRST_PREDICTION_MODAL_KEY_PREFIX = 'firstPredictionModalShown';
export const FIRST_CATEGORY_TRADE_MODAL_KEY_PREFIX = 'firstCategoryTradeModalShown';
export const SURVIVOR_INTRO_REQUEST_SENT = 'survivor_intro_request_sent';
export const SURVIVOR_INTRO_MODAL_SEEN = 'survivor_intro_modal_seen';
